<template>
  <v-app>
    <NavBar />
    <v-main class="accent">
      <router-view/>
    </v-main>
  </v-app>
</template>

<script>
  import NavBar from './components/NavBar.vue';

export default {
  name: 'App',

  components: {
    NavBar
  },
  data: () => ({
    showNewFormulaDialog: false
  }),
};
</script>

<style>
.mtfont {
  font-family: 'Montserrat', sans-serif;
}
.appBarLogo {
  font-size: 29px;
}
.appBarDivider {
  border-color: black !important;
  border-width: 2px !important;
  margin-top: 10px;
  margin-bottom: 10px;
}

input {
  caret-color: black;
}
</style>
